import React, { Component } from "react";
import Dock from "react-dock";
import { gql } from "@apollo/client";
import { Switch, Route } from "react-router-dom";
import "./ArchivedExplorer.scss";
import SideBar from "../../components/SideBar/SideBar";
import RightArrow from "../../assets/icons/arrows/right_arrow.svg";
import ArchivedListView from "../../components/ArchivedListView/ArchivedListView";
import Aux from "../../hoc/Aux/Aux";
import { apolloClient } from "../..";
import dateFormat from "dateformat";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../common/UserDataReducer";
import { Spinner } from "react-bootstrap";

class ArchivedExplorer extends Component {
  state = {
    archivedItems: [],
    archivedList: [],
    archiveSubFolders: [],
    isVisible: false,
    isArchived: true,
    isLoading: true,
  };

  loadArchiveSubFolders = (folder) => {
    const variables = {
      parentFolderId: folder.id,
    };
    apolloClient
      .query({
        query: gql`
          query ArchiveSubFolders($parentFolderId: UUID!) {
            archiveSubFolders(parentFolderId: $parentFolderId) {
              id
              title
              color {
                id
                name
              }
              parentFolder {
                id
                title
                color {
                  id
                }
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        result.data.archiveSubFolders.map((sub) => {
          sub.folderId = sub.id;
          return true;
        });
        const newList = [...this.state.archivedList];
        const rootFolder = newList.find((list) => list.id === folder.id);
        const newObj = !rootFolder && {
          id: folder.id,
          color: folder.color,
          title: folder.title,
        };
        newObj.subfolders = [...result.data.archiveSubFolders];
        !rootFolder && newList.push({ ...newObj });
        this.setState({ archivedList: newList });
      })
      .catch((e) => {});
  };

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query {
            userArchives {
              id
              folder {
                id
                title
                color {
                  id
                  name
                }
                parentFolder {
                  id
                  title
                  color {
                    id
                  }
                }
              }
              document {
                id
                title
                folder {
                  id
                  title
                  color {
                    id
                    name
                  }
                  parentFolder {
                    id
                    title
                    color {
                      id
                    }
                  }
                }
              }
              createdBy {
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              createdTs
              archivedTillTs
            }
          }
        `,
      })
      .then((result) => {
        let newArchivedItems = [],
          newArchivedList = [];
        result.data.userArchives.map((archive) => {
          let archiveFolder = archive.folder
            ? archive.folder
            : archive.document.folder;

          if (archiveFolder.parentFolder) {
            const newObj = Object.assign({}, archive, {
              id: archive.folder ? archiveFolder.id : archive.document.id,
              color: archiveFolder.color,
              rootId: archiveFolder.parentFolder.id,
              rootTitle: archiveFolder.parentFolder.title,
              parentId: archiveFolder.id,
              parentTitle: archiveFolder.title,
              archivedBy: archive.createdBy,
              role: archive.createdBy.profile.role.name,
              archivedOn: dateFormat(archive.createdTs, "mmm dd, yyyy"),
              archivedTill: dateFormat(archive.archivedTillTs, "mmm dd, yyyy"),
              isFolder: archive.folder !== null,
            });

            newArchivedItems.push({ ...newObj });
            const newObj2 = Object.assign(
              {},
              {
                id: archiveFolder.parentFolder.id,
                title: archiveFolder.parentFolder.title,
                color: archiveFolder.parentFolder.color,
                subfolders: [
                  {
                    id: archiveFolder.id,
                    folderId: archiveFolder.id,
                    title: archiveFolder.title,
                    color: archiveFolder.color,
                    parentFolder: archiveFolder.parentFolder,
                  },
                ],
              }
            );

            let check = false;
            newArchivedList.map((newList) => {
              const checkParent = newList.id === newObj2.id;
              if (checkParent) {
                let checkSubfolder = false;
                newList.subfolders.map((subfolder) => {
                  const checksubfolder =
                    subfolder.folderId === archiveFolder.id;
                  if (checksubfolder) {
                    checkSubfolder = checksubfolder;
                  }
                  return true;
                });

                !checkSubfolder &&
                  newList.subfolders.push({
                    id: archiveFolder.id,
                    folderId: archiveFolder.id,
                    title: archiveFolder.title,
                    color: archiveFolder.color,
                    parentFolder: archiveFolder.parentFolder,
                  });
                check = checkParent;
              }
              return true;
            });
            !check && newArchivedList.push({ ...newObj2 });
          } else {
            this.loadArchiveSubFolders(archiveFolder);
            const newObj = Object.assign({}, archive, {
              id: archiveFolder.id,
              color: archiveFolder.color,
              rootId: null,
              rootTitle: null,
              parentId: archiveFolder.id,
              parentTitle: archiveFolder.title,
              archivedBy: archive.createdBy,
              role: archive.createdBy.profile.role.name,
              archivedOn: dateFormat(archive.createdTs, "mmm dd, yyyy"),
              archivedTill: dateFormat(archive.archivedTillTs, "mmm dd, yyyy"),
              isFolder: archive.folder !== null,
            });

            newArchivedItems.push({ ...newObj });
          }
          return true;
        });
        this.setState({
          archivedItems: newArchivedItems,
          archivedList: newArchivedList,
          isLoading: false,
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
      });
  }

  handleViewSidebar = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  setFolderList = (lists, archives) => {
    // update archived lists
    const parentIds = [];
    const subfolders = {};
    lists.map((list) => {
      if (list.folder) {
        if (list.folder.parentFolder) {
          !parentIds.includes(list.folder.parentFolder.id) &&
            parentIds.push(list.folder.parentFolder.id);

          !subfolders[list.folder.parentFolder.id]
            ? (subfolders[list.folder.parentFolder.id] = [list.folder.id])
            : subfolders[list.folder.parentFolder.id].push(list.folder.id);
        } else {
          !parentIds.includes(list.folder.id) && parentIds.push(list.folder.id);

          const archiveList = [...this.state.archivedList];
          const filterList = archiveList.find(
            (arc) => arc.id === list.folder.id
          );
          const subIds = [];
          filterList &&
            filterList.subfolders.map(
              (filter) =>
                archives.find((arc) => arc.id !== filter.id) &&
                subIds.push(filter.id)
            );
          !subfolders[list.folder.id] && (subfolders[list.folder.id] = subIds);
        }
      } else {
        if (list.document.folder.parentFolder) {
          !parentIds.includes(list.document.folder.parentFolder.id) &&
            parentIds.push(list.document.folder.parentFolder.id);

          const archiveList = [...this.state.archivedList];
          const filterList = archiveList.find((arc) => arc.id === list.rootId);
          const subIds = [];
          filterList &&
            filterList.subfolders.map((filter) => subIds.push(filter.id));
          !subfolders[list.document.folder.parentFolder.id] &&
            (subfolders[list.document.folder.parentFolder.id] = subIds);
        } else {
          !parentIds.includes(list.document.folder.id) &&
            parentIds.push(list.document.folder.id);

          !subfolders[list.document.folder.id]
            ? (subfolders[list.document.folder.id] = [list.document.folder.id])
            : subfolders[list.document.folder.id].push(list.document.folder.id);
        }
      }
      return true;
    });
    const newArchivedList = [...this.state.archivedList];
    const updatedArchivedList = newArchivedList.filter((newList) =>
      parentIds.includes(newList.id)
    );
    const updatedArchivedList2 = [];
    updatedArchivedList.map((newList) => {
      const newArr = newList.subfolders.filter((sub) =>
        subfolders[newList.id].includes(sub.id)
      );
      let newArr2 = { ...newList };
      newArr2.subfolders = newArr;
      updatedArchivedList2.push(newArr2);
      return true;
    });

    // update archived items
    const filterArchives = archives.map((archive) => archive.id);
    const updatedArchives = [...this.state.archivedItems];
    const updateFilteredArchive = updatedArchives.filter(
      (updatedArchive) => !filterArchives.includes(updatedArchive.id)
    );

    this.setState({
      archivedList: updatedArchivedList2,
      archivedItems: updateFilteredArchive,
    });
  };

  render() {
    let contentClass = this.state.isVisible ? " content open" : "content";
    return (
      <Aux>
        <div className="container-fluid archived-wraper" id="style-scroll">
          <div className="row">
            <div className="custom-dock">
              <Dock
                position="left"
                dimMode="none"
                isVisible={this.state.isVisible}
                defaultSize={0.27}
              >
                <SideBar
                  isOpen={this.state.isVisible}
                  toggleSidebar={this.handleViewSidebar}
                  folderList={this.state.archivedList}
                  isArchived={this.state.isArchived}
                />
              </Dock>
            </div>
            <div
              className={[
                contentClass,
                "col-md justify-content-between d-flex",
              ].join(" ")}
            >
              <div className="sidedrawer-line" onClick={this.handleViewSidebar}>
                <img height="12" width="12" src={RightArrow} alt="arrow" />
              </div>
                   
              {this.state.isLoading ? (
                <div className="loader-icon">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <>
                {this.props.match.path === "/archives" ? (
                  <ArchivedListView
                    archivedItems={this.state.archivedItems}
                    setFolderList={(list, restore) =>
                      this.setFolderList(list, restore)
                    }
                    isSubFolderArchive={false}
                    isLoading={this.state.isLoading}
                    {...this.props}
                  />
                ) : null}
                <Switch>
                  <Route
                    exact
                    path="/archives/:folderId"
                    component={() => (
                      <ArchivedListView
                        archivedItems={this.state.archivedItems}
                        setFolderList={(list, restore) => this.setFolderList(list, restore)}
                        isSubFolderArchive={true}
                        isSubArchive={true}
                        isLoading={this.state.isLoading}
                        {...this.props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/archives/:folderId/:subId"
                    component={() => (
                      <ArchivedListView
                        archivedItems={this.state.archivedItems}
                        setFolderList={(list, restore) => this.setFolderList(list, restore)}
                        // isSubFolderArchive={true}
                        isDocumentArchive={true}
                        isLoading={this.state.isLoading}
                        {...this.props}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/archives/:folderId/:subId/:docId"
                    render={() => (
                      <ArchivedListView
                        archivedItems={this.state.archivedItems}
                        setFolderList={(list, restore) => this.setFolderList(list, restore)}
                        // isSubFolderArchive={true}
                        isDocumentArchive={true}
                        isLoading={this.state.isLoading}
                        {...this.props}
                      />
                    )}
                  />
                </Switch>
                </>
              )}
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedExplorer);
